import { useLocation } from 'react-router-dom'

export function useIsDemoAppMode() {
  const location = useLocation()
  // For now, just look to see if there is a /app/ segment in the path
  // Only using this for the demo mode of entity explorer, may be more sophisticated in the future
  return location.pathname.includes('/app/')
}
